"use client";

import { dynamicChart } from "@/components/charts/dynamicChart";

export type { CostPerPermitProps } from "./CostPerPermitChart.impl";

export const CostPerPermitChart = dynamicChart(
  () => import("./CostPerPermitChart.impl").then((m) => m.CostPerPermitChart),
  300,
);
